export type PreAuthChallenge = {
  token: string
  expiresAt: string | null
}

let pending: PreAuthChallenge | null = null

export const holdPreAuth = (challenge: PreAuthChallenge): void => {
  pending = challenge
}

export const readPreAuth = (): PreAuthChallenge | null => pending

export const clearPreAuth = (): void => {
  pending = null
}

export const preAuthExpired = (challenge: PreAuthChallenge, now = Date.now()): boolean => {
  if (challenge.expiresAt === null) {
    return false
  }

  const expiry = new Date(challenge.expiresAt).getTime()

  return Number.isFinite(expiry) && expiry <= now
}
